export const chargeServicesDrawer = {
  title: "الرسوم والخدمات",
  closeAria: "إغلاق",
  subtitle: {
    catalog: "كتالوج قابل لإعادة الاستخدام في فواتيرك",
    select: "اختر البنود التي تريد إضافتها",
  },
  searchPlaceholder: "ابحث عن خدمة…",
  createService: "إنشاء خدمة",
  loading: "جارٍ تحميل الخدمات…",
  empty: "ليس لديك أي خدمات بعد. أنشئ أول خدمة.",
  item: {
    vat: "ضريبة {vat}%",
    edit: "تعديل",
    delete: "حذف",
  },
  footer: {
    selected: "{count} عنصر محدَّد | {count} عناصر محدَّدة",
    createInvoice: "إنشاء فاتورة بهذه البنود",
    addToInvoice: "إضافة إلى الفاتورة",
  },
  form: {
    editTitle: "تعديل الخدمة",
    newTitle: "خدمة جديدة",
    subtitle: "بند قابل لإعادة الاستخدام في فواتيرك",
    photoLabel: "صورة",
    optional: "اختياري",
    uploadPhoto: "رفع",
    nameLabel: "الاسم",
    namePlaceholder: "مثال: التنظيف النهائي",
    categoryLabel: "الفئة",
    categoryPlaceholder: "مثال: التنظيف",
    priceLabel: "السعر",
    vatLabel: "ضريبة القيمة المضافة",
    descriptionLabel: "الوصف",
    descriptionPlaceholder: "التفاصيل التي ستظهر في الفاتورة",
    cancel: "إلغاء",
    save: "حفظ التغييرات",
    create: "إنشاء خدمة",
  },
  toasts: {
    loadError: "تعذّر تحميل الخدمات.",
    photoError: "تعذّر رفع الصورة.",
    updated: "تم تحديث الخدمة.",
    created: "تم إنشاء الخدمة.",
    saveError: "تعذّر حفظ الخدمة.",
    deleteError: "تعذّر الحذف.",
  },
  confirmDelete: 'حذف "{name}" من الكتالوج؟',
};
